import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "auth-card" }
const _hoisted_2 = { class: "auth-card__header" }
const _hoisted_3 = { class: "auth-card__logo" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["type"]
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_12 = { class: "text-start mb-3" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "spinner-border spinner-border-sm ms-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "text-center mt-3 mb-0 auth-switch" }

import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import ErrorMessage from "@/components/common/ErrorMessage.vue";
import AuthPageLayout from "@/components/auth/AuthPageLayout.vue";
import BrandLogo from "@/components/BrandLogo.vue";
import { followAuthRedirect } from "@/utils/authSession";


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const { login, loading, error } = useAuth();

const mobile = ref("");
const password = ref("");
const showPassword = ref(false);
const mobileError = ref("");
const passwordError = ref("");
const errorMessage = ref("");

const MOBILE_PATTERN = /^\+?\d{7,15}$/;

function normalizeMobile(value) {
  return value.replace(/[\s-]/g, "");
}

function validate() {
  let ok = true;
  mobileError.value = "";
  passwordError.value = "";

  const normalized = normalizeMobile(mobile.value);
  if (!normalized) {
    mobileError.value = "لطفاً شماره موبایل خود را وارد کنید.";
    ok = false;
  } else if (!MOBILE_PATTERN.test(normalized)) {
    mobileError.value = "شماره موبایل معتبر وارد کنید (فقط عدد).";
    ok = false;
  }

  if (!password.value) {
    passwordError.value = "لطفاً رمز عبور خود را وارد کنید.";
    ok = false;
  }

  return ok;
}

async function onSubmit() {
  errorMessage.value = "";
  if (!validate()) return;

  const success = await login(normalizeMobile(mobile.value), password.value);

  if (success) {
    const redirect =
      typeof route.query.redirect === "string" ? route.query.redirect : "/dashboard";
    followAuthRedirect(redirect, "/dashboard", (path) => {
      router.push(path);
    });
  } else {
    errorMessage.value = error.value || "شماره موبایل یا رمز عبور نادرست است.";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(AuthPageLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(BrandLogo, { size: "md" })
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "auth-card__icon" }, [
            _createElementVNode("i", { class: "bi bi-phone" })
          ], -1)),
          _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "auth-card__title" }, "ورود", -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "auth-card__subtitle" }, "برای ادامه شماره موبایل خود را وارد کنید", -1))
        ]),
        (errorMessage.value)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              title: "ورود انجام نشد",
              message: errorMessage.value,
              retryable: false,
              class: "mb-3"
            }, null, 8, ["message"]))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _withModifiers(onSubmit, ["prevent"]),
          novalidate: ""
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[9] || (_cache[9] = _createElementVNode("label", {
              for: "mobile",
              class: "form-label"
            }, "شماره موبایل", -1)),
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "input-group-text" }, [
                _createElementVNode("i", { class: "bi bi-telephone" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "mobile",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mobile).value = $event)),
                type: "tel",
                inputmode: "tel",
                autocomplete: "tel",
                class: _normalizeClass(["form-control", { 'is-invalid': mobileError.value }]),
                placeholder: "مثال: 09123456789",
                onInput: _cache[1] || (_cache[1] = ($event: any) => (mobileError.value = ''))
              }, null, 34), [
                [
                  _vModelText,
                  mobile.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            (mobileError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(mobileError.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              for: "password",
              class: "form-label"
            }, "رمز عبور", -1)),
            _createElementVNode("div", _hoisted_8, [
              _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text" }, [
                _createElementVNode("i", { class: "bi bi-lock" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                id: "password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
                type: showPassword.value ? 'text' : 'password',
                autocomplete: "current-password",
                class: _normalizeClass(["form-control", { 'is-invalid': passwordError.value }]),
                placeholder: "رمز عبور شما",
                onInput: _cache[3] || (_cache[3] = ($event: any) => (passwordError.value = ''))
              }, null, 42, _hoisted_9), [
                [_vModelDynamic, password.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-outline-secondary toggle-pass",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showPassword.value = !showPassword.value)),
                "aria-label": showPassword.value ? 'مخفی کردن رمز عبور' : 'نمایش رمز عبور'
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(showPassword.value ? 'bi bi-eye-slash' : 'bi bi-eye')
                }, null, 2)
              ], 8, _hoisted_10)
            ]),
            (passwordError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(passwordError.value), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: "/forgot-password",
              class: "auth-link"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode(" رمز عبور را فراموش کرده‌اید؟ ", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "btn auth-btn w-100",
            disabled: _unref(loading)
          }, [
            (_unref(loading))
              ? (_openBlock(), _createElementBlock("span", _hoisted_14))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_unref(loading) ? "در حال ورود..." : "ورود"), 1)
          ], 8, _hoisted_13),
          _createElementVNode("p", _hoisted_15, [
            _cache[14] || (_cache[14] = _createTextVNode(" حساب کاربری ندارید؟ ", -1)),
            _createVNode(_component_router_link, { to: "/signup" }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("ثبت‌نام", -1)
              ]))]),
              _: 1
            })
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}
}

})